/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyIn3DAuthenticateOutput
 */
export interface MoneyIn3DAuthenticateOutput {
    /**
     * Atos return code:
     * 00: Authenticated owner
     * 55: Owner not authenticated
     * 62: Owner By-pass on ACS
     * @type {string}
     * @memberof MoneyIn3DAuthenticateOutput
     */
    operation3DCode?: string;
    /**
     * 
     * @type {Error}
     * @memberof MoneyIn3DAuthenticateOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyIn3DAuthenticateOutput interface.
 */
export function instanceOfMoneyIn3DAuthenticateOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyIn3DAuthenticateOutputFromJSON(json: any): MoneyIn3DAuthenticateOutput {
    return MoneyIn3DAuthenticateOutputFromJSONTyped(json, false);
}

export function MoneyIn3DAuthenticateOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyIn3DAuthenticateOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'operation3DCode': !exists(json, 'Operation3DCode') ? undefined : json['Operation3DCode'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyIn3DAuthenticateOutputToJSON(value?: MoneyIn3DAuthenticateOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Operation3DCode': value.operation3DCode,
        'error': value.error,
    };
}

